"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stakingContractValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.stakingContractValidationSchema = (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    imageUrl: yup_rules_1.urlValidationSchema,
});
//# sourceMappingURL=validation.js.map